import { LessonProgressCard } from '@/components/lesson/LessonProgressCard';
import UnitLessonCard from '@/components/lesson/UnitLessonCard';
import LessonProgressDashboardStats from '@/models/LessonProgressDashboardStats';
import { toStudentLessonItems } from '@/utils/lesson/lessonItems';
import { formatLessonName } from '@/utils/lesson/name';
import { CourseRoute } from '@/utils/routes';

type UnitLessonProgressItemProps = CourseRoute & {
  lessonProgress: LessonProgressDashboardStats;
};

export default function UnitLessonProgressItem({
  lessonProgress,
  ...route
}: UnitLessonProgressItemProps) {
  const { lesson, progress } = lessonProgress;

  return (
    <UnitLessonCard
      {...route}
      lesson={lesson}
      name={formatLessonName(lesson)}
      items={toStudentLessonItems(lessonProgress)}
      highlighted={progress > 0 && progress < 1}
    >
      <LessonProgressCard.Progress progress={progress} />
    </UnitLessonCard>
  );
}
